import { Locale } from '51trips-frontend-core'

export enum AppLanguages {
  ca = 'ca',
  en = 'en',
  es = 'es',
  fr = 'fr',
  it = 'it'
}

export enum LocalLanguages {
  esES = 'es-ES'
}

export const DEFAULT_LOCALE = new Locale('US', 'en-US', 'en', false)
